import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { swiperControlsConfig } from '../../../../../../src/js/utils/swiper-controls'

function initHighlightsSliders() {
    document.querySelectorAll('.highlights-swiper').forEach((el) => {
        if (el.swiper) return

        const root = el.closest('.highlights-slider')
        const enableAutoplay = el.dataset.autoplay === 'true'

        new Swiper(el, {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            loop: false,
            speed: 900,
            grabCursor: true,
            watchOverflow: true,
            resistanceRatio: 0.85,
            longSwipesRatio: 0.25,
            autoplay: enableAutoplay
                ? {
                      delay: 4500,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                  }
                : false,
            ...swiperControlsConfig(root),
            breakpoints: {
                768: { spaceBetween: 24 },
                1024: { spaceBetween: 28 },
            },
        })
    })
}

document.addEventListener('DOMContentLoaded', initHighlightsSliders)
